import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryString } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let contactApiPromise: Promise<AxiosInstance> | null = null;

const getContactApi = async (): Promise<AxiosInstance | null> => {
  if (contactApiPromise) return contactApiPromise;
  contactApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return contactApiPromise;
};

export interface ContactRequest {
  id: number;
  Dni: string;
  Nombre: string;
  Apellido: string;
  Telefono: string;
  Mail: string;
  idEstado: number;
  Estado: string;
  FechaCreacion: string;
  FechaActualizacion: string;
}

export interface GetContactRequestListProps {
  Nombre?: string;
  Apellido?: string;
  Email?: string;
  Telefono?: string;
  FechaDesde?: string;
  FechaHasta?: string;
  IdEstado?: number[];
  "P.Pagina"?: number;
  "P.Records"?: number;
}

export interface GetContactRequestListResponse {
  listado: ContactRequest[];
  totalPages: number;
  totalRecords: number;
}

export const getContactRequests = async (
  props: GetContactRequestListProps,
): Promise<GetContactRequestListResponse | null> => {
  const api = await getContactApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudContacto/GetListadoSolicitudContacto?${objectToQueryString(props)}`,
  );

  return response.data;
};

export interface UpdateContactRequestProps {
  Id: number;
}

export const updateContactRequest = async (
  props: UpdateContactRequestProps,
) => {
  const api = await getContactApi();
  if (!api) return null;
  const response = await api.put(
    `/SolicitudContacto/PutSolicitudContactoContactado?${objectToQueryString(props)}`,
  );

  return response;
};
